import {makeEnumTypeGuard} from '../../models/api/types/enumTypes';

export enum FeatureFlagsEnum {
  ADMIN_COMMAND_CENTER_P_0_ENTRY_POINT = 'admin-command-center-p-0-entry-point',
  AI_AUTOPILOT_BILLING = 'ai-autopilot-billing',
  API_DASHBOARD = 'api-dashboard',
  AI_COMPOSE_V2_FLOATING_BUTTON = 'ai-compose-v2-floating-button',
  AI_DISABLE_COMPOSE_WHEN_TOO_SHORT = 'ai-disable-compose-when-too-short',
  AI_ECHO_CONFIDENCE_SCORE = 'ai-echo-confidence-score',
  AI_ECHOES_HUB_MERGE_MODAL = 'ai-echoes-hub-merge-modal',
  AI_FACT_INVALIDATION = 'ai-fact-invalidation',
  AI_TAGGING_TAG_LIMIT = 'ai-tagging-tag-limit',
  AI_AUTOPILOT_REPORT = 'analytics-ai-autopilot-report',
  AI_PROMPT_IN_EXPRESSIONS = 'ai-prompt-in-dv',
  AI_REPLIES_PAGE = 'ai-replies-page',
  ANALYTICS_CHATBOTS_AI_ANSWERS_CATEGORIES_TABLE = 'analytics-chatbots-ai-answers-categories-table',
  ANALYTICS_DEPRECATED_REPORTS = 'analytics-deprecated-reports',
  ANALYTICS_DYNAMIC_TABLE_COLUMNS = 'analytics-dynamic-table-columns',
  ANALYTICS_WORKLOAD_TOUR = 'analytics-workload-tour',
  ANALYTICS_ES_TO_CH_DATA_MIGRATION = 'analytics_es_to_ch_data_migration',
  ANALYTICS_AI_REPORTS_V1 = 'analytics-ai-reports-v1',
  APPLICATION_CONNECTOR_DEVELOPERS = 'application-connectors-developers',
  APPLICATION_CONNECTOR_MULTI_REQUEST = 'multi-request-application-connectors',
  APPLICATION_CONNECTOR_OUTPUT_PRETTY_JSON = 'application-connector-output-pretty-json',
  APP_REQUEST_PAGINATION = 'app-request-pagination',
  APP_REQUEST_SEARCH = 'app-request-search',
  APPLICATION_OAUTH2_PASSWORD_GRANT_TYPE = 'application-oauth-2-password-grant-type',
  ASK_COPILOT = 'ask-copilot',
  AUTOCOMPLETE_MORE_RESULTS = 'autocomplete-more-results',
  CELLS_OFFLINE_CACHE = 'cells-conversations-caching',
  CELLS_OFFLINE_CACHE_REPORTING = 'cells-offline-cache-reporting',
  CHAT_AI_DISPATCHER = 'chat-ai-dispatcher',
  CHAT_WIDGET_REFRESH = 'chat-widget-refresh',
  CHANNELS_RECOMMENDATIONS = 'channels-recommendations',
  CHAT_ONBOARDING_IMPROVEMENTS = 'chat-onboarding-improvements',
  CHATBOT_DYNAMIC_VARIABLE_BETWEEN_TIME_OPERATION = 'chatbot-dynamic-variable-between-time-operation',
  CHATBOT_HISTORY = 'chat-history-csv-download',
  CHATBOT_PREVIEW = 'chatbot-preview',
  CHAT_SELF_SERVE_EXPERIENCE_FOR_FRONT_USERS = 'chat-self-serve-experience-for-front-users',
  CLOSED_CONVERSATIONS = 'closed-conversations-ga',
  COMPANY_ENFORCED_SIGNATURES = 'company-enforced-signatures',
  CONDITIONS_TOKEN_EDITOR = 'conditions-tokens-editor',
  CONTACTS_OTHER_NAMES_DIALOG = 'contacts-other-names-dialog',
  CONVERSATION_SYNOPSIS = 'conversation-synopsis',
  CONVERSATION_UNDO_BANNER_REDESIGN = 'conversation-undo-banner-redesign',
  CREATE_CALENDAR_EVENT_VERSION_FROM_ORPHAN = 'create-calendar-event-version-from-orphan',
  CREATE_CALENDAR_EVENT_VERSION_FROM_ORPHAN_OFFICE_365 = 'create-calendar-event-version-from-orphan-office-365',
  CUSTOM_PLUGIN_RELAY = 'custom-plugin-relay',
  CUSTOMER_PORTAL = 'customer-portal',
  CUSTOMER_PORTAL_FORM_PREVIEW = 'customer-portal-form-preview',
  DATA_GROUP_INSTRUMENTATION = 'data-group-instrumentation',
  DATADOG_RUM = 'datadog-rum',
  DEEP_PERFORMANCE_INSTRUMENTATION = 'deep-performance-instrumentation',
  RINGCENTRAL_RELEASE_ANNOUNCEMENT = 'ringcentral-release-announcement',
  DRAFT_CHECKSUM = 'draft-checksum',
  DROPDOWN_REDESIGN = 'dropdown-redesign',
  EDIT_PUBLISHED_APPLICATIONS = 'edit-published-applications',
  ENFORCE_CHANNELS_TEAMMATE_RATIO = 'enforce-channels-teammate-ratio',
  SETTINGS_COPILOT = 'settings-copilot',
  FEATURE_HELP_REQUEST_CTA = 'feature-help-request-cta',
  FRONT_CHAT_POWERED_BY = 'front-chat-powered-by',
  FRONT_MAIL = 'enable-front-mail',
  GLG_INDIVIDUAL_RULE_WARNING = 'glg-individual-rule-warning',
  GRANULAR_OFFLINE_INDICATION = 'granular-offline-indication',
  HAS_CUSTOM_VIEWS = 'has-custom-views',
  HIDE_ASSIGNED_CONVERSATIONS = 'hide-assigned-conversations',
  HIDE_AUDIT_TRAIL = 'hide-audit-trail',
  HIDE_PRIVATE_CATEGORIES_P4 = 'hide-private-categories-p4',
  HIDE_TEAM_TAG_COUNTERS = 'hide-team-tag-counters',
  AI_COMPOSE_ASSISTANT = 'ai-compose-assistant',
  AI_COMPOSE_ASSISTANT_DEV = 'ai-compose-assistant-dev',
  INBOX_REDESIGN_ANNOUNCEMENT = 'inbox-redesign-announcement',
  INBOX_REDESIGN_FORCE_ENABLE_VERSIONED = 'inbox-redesign-force-enable-versioned',
  INBOX_REDESIGN_GA = 'inbox-redesign-ga',
  INBOX_REDESIGN_P3_SUBJECT_TWO_LINES = 'inbox-redesign-p3-subject-two-lines',
  INBOX_ICON_IN_CELL = 'inbox-icon-in-cell',
  INCIDENT_MANAGEMENT = 'incident-management',
  INCORRECT_ARCHITECTURE_BANNER_ENABLED = 'incorrect-architecture-banner-enabled',
  INTERNAL_AI_ANSWERS_ANNOUNCEMENT = 'internal-ai-answers-announcement',
  INTERNAL_TASKS = 'internal-tasks-versioned',
  INTERNAL_TASKS_STANDALONE = 'internal-tasks-standalone-versioned',
  INTERNAL_TOOLBAR = 'internal-toolbar',
  JIRA_PREBUILT_CONNECTORS = 'jira-prebuilt-connectors',
  JUMP_TO_BEGINNING_BANNER = 'jump-to-beginning-banner',
  KNOWLEDGE_BASE_ARTICLE_REACTIONS = 'knowledge-base-article-reactions',
  KNOWLEDGE_BASE_CONTACT_FORM_ADDITIONAL_FIELDS = 'knowledge-base-contact-form-additional-fields',
  KNOWLEDGE_BASE_END_USER_AUTH = 'restricted-kb-end-user-auth',
  KNOWLEDGE_BASE_PORTAL_ANALYTICS = 'knowledge-base-portal-analytics',
  KNOWLEDGE_BASE_STALE_ARTICLES_V2 = 'knowledge-base-stale-articles-v2',
  LEGACY_PLAN_MIGRATION = 'legacy-plan-migration',
  LENSES_INCREASED_INBOX_LIMIT = 'lenses-increased-inbox-limit',
  LINKED_DISCUSSIONS = 'linked-discussions',
  LOG_DRAG_AND_DROP_OPERATIONS = 'log-drag-and-drop-operations',
  MACRO_DRAFT = 'macro-draft',
  MESSAGE_TRANSLATION = 'message-translation-banner',
  MOBILE_CALENDAR_WRITE_GA = 'mobile-calendar-write-ga',
  MOBILE_COMPOSER_DRAFT_FIX = 'mobile-composer-draft-fix',
  MOBILE_IMPROVED_EMAIL_RENDERING = 'mobile-improved-html-rendering',
  MOBILE_PREFETCHER = 'mobile-prefetcher',
  MORE_P2_PREFETCH = 'more-p2-prefetch',
  NEW_P3_PREFETCH = 'new-p3-prefetch',
  NEW_PREFETCH_V3 = 'new-prefetch-v3',
  OFFICE_365_IMPORTER_DEPRECATION = 'office-365-importer-deprecation',
  OFFLINE_CONVERSATION_CACHE = 'offline-conversation-cache',
  OLD_DESKTOP_VERSION_BANNER = 'old-desktop-version-banner',
  ONBOARDING_CHAT_AUTOMATION = 'onboarding-chat-automation',
  ONBOARDING_FLOW_V5 = 'onboarding-flow-v5',
  SKIP_QUOTE_HTML_IF_QUOTE_IS_NOT_INCLUDED = 'skip-quote-html-if-quote-is-not-included',
  P2_CELLS_REDESIGN_PHASE_2 = 'p2-cells-redesign-phase-2',
  P2_FILTER_MULTISELECT_REDESIGN = 'p2-filter-multiselect-redesign',
  P2_FILTERS_REDESIGN = 'p2-filters-redesign',
  P2_SERVER_BOUNDARY = 'p2-server-boundary',
  P4_POP_OUT_ANY_PLUGIN = 'p4-pop-out-any-plugin',
  P4_START_GUIDE_HIDDEN = 'p4-start-guide-hidden',
  SMART_QA_IN_WORKSPACE = 'smart-qa-in-workspace',
  PERFORMANCE_DEBUG_LOGGING = 'performance-debug-logging',
  PERFORMANCE_METRIC_LOGGING_DESKTOP = 'performance-metric-logging',
  PERFORMANCE_METRIC_LOGGING_MOBILE = 'performance-metric-logging-mobile',
  POLICY_VIOLATION_WARNING = 'policy-violation-warning',
  PRE_CHAT_FORM_ENABLED = 'pre-chat-form-enabled',
  PRIVATE_AI_KNOWLEDGE_SOURCES = 'private-application-ai-knowledge-sources',
  PRELOADED_CONVERSATIONS = 'preloaded-conversations',
  PREVENT_PIN_TEAM_TAGS = 'team-lenses-prevent-pin-team-tags',
  LEGACY_SLACK_ACCESS = 'legacy-slack-channel-access',
  MACRO_BUTTON_IN_COMPOSER_TOOLBAR = 'macro-button-in-composer-toolbar',
  PUSH_ROOM_RECEIVING_LOGGING = 'push-room-receiving-logging',
  QUICK_CONNECT_CHANNELS = 'quick-connect-channels',
  QUICK_INSERT_TABLE = 'quick-insert-table',
  REACT_18_STRICT_MODE = 'react-18-strict-mode',
  REPEAT_FORMATTING = 'repeat-formatting',
  REQUEST_TRACE_TAG = 'request-trace-tag',
  RTL_LANGUAGE_SUPPORT = 'rtl-language-support',
  RULE_EDITOR_HIGHLIGHT_ERRORS = 'rule-editor-highlight-errors',
  RULE_REMOVE_FROM_ASSIGNMENT_QUEUES_ACTION = 'rule-clear-assignment-queues-action',
  RULES_DRY_RUN = 'rules-dryrun',
  SEARCH_ENGLISH_STEMMER = 'search-english-stemmer',
  SEARCH_EMPTY_BEHAVIOR = 'search-empty-behavior',
  SEARCH_LOCATION_RESET_EXPERIMENT = 'search-location-reset-experiment',
  SEARCH_NEGATED_FILTERS = 'search-negated-filters',
  SEARCH_NEGATED_QUICK_FILTERS = 'search-negated-quick-filters',
  SELECTOR_PERFORMANCE_LOGGING = 'selector-performance-logging',
  SENDGRID_DNS_SUBUSER = 'sendgrid-dns-subuser',
  SERVICE_WORKER = 'service-worker',
  SETTINGS_HOMEPAGE = 'settings-homepage-client',
  SETTINGS_PREVIEWERS = 'settings-previewers',
  SETUP_GUIDE_DISCOVER_AI = 'setup-guide-discover-ai',
  SHARED_ACTIONS = 'shared-actions',
  SHOW_FRONT_CHAT_VISITOR_URL_RULE = 'show-front-chat-visitor-url-rule',
  SHOW_MARKDOWN_EMAIL_COMPOSER = 'show-markdown-email-composer',
  SINGLE_CONTACT_SYNC = 'single-contact-sync',
  SKIP_ARCHIVE_WHEN_CHANGING_OTHER_ASSIGNEES = 'skip-archive-when-changing-other-assignees',
  SORT_P2_BY_SLA_TIMER = 'sort-p2-sla',
  SPLIT_SINGLE_THREADED_CONVOS = 'split-single-threaded-convos',
  STANDALONE_PORTAL = 'standalone-portal',
  SUPPORT_AT_SCALE_ANNOUNCEMENT = 'support-at-scale-announcement',
  SUPPORT_CHAT_FALLBACK = 'support-chat-fallback',
  SW_BOOT_CACHE_PATCHING = 'sw-boot-cache-patching',
  TABLE_PASTE_IGNORE_PASTEASTEXT_PREFERENCE = 'table-paste-ignore-pasteastext-preference',
  RINGCENTRAL = 'ringcentral',
  SLACK_RELEASE_ANNOUNCEMENT = 'slack-release-announcement',
  TICKET_STATUS_GROUPS = 'ticket-status-groups',
  TICKETING_CUSTOM_STATUSES = 'ticketing-custom-statuses',
  TICKETING_CUSTOM_STATUSES_WORKFLOWS = 'custom-ticket-statuses-in-workflows',
  TRIGGERED_SUGGESTIONS = 'triggered-suggestions',
  WORKSPACE_PERMISSIONS = 'workspace-permissions',
  P1_EDIT_WORKSPACE_REDESIGN = 'p1-edit-workspace-redesign',
  P1_REORDER_WORKSPACE_SECTIONS = 'p1-reorder-workspace-sections',
  P1_WORKSPACE_CUSTOMIZATION_TOUR = 'p1-workspace-customization-tour',
  MESSAGE_TEMPLATE_PREVIEWS = 'message-template-previews',
  MOBILE_INBOX_REDESIGN_TOGGLE = 'mobile-inbox-redesign-toggle',
  CONVERSATION_QUARANTINE = 'conversation-quarantine',
  SETTINGS_DARK_MODE = 'settings-dark-mode',
  USER_SURVEY = 'user-survey',
  OUTBOUND_RULE_VALIDATION = 'outbound-rule-validation',
  SETTINGS_COPILOT_STREAMING = 'settings-copilot-streaming',
  SETTINGS_COPILOT_NODE_STEPS = 'settings-copilot-node-steps',
  MENTIONS_IN_EMAIL_COMPOSER = 'mentions-in-email-composer',
  AI_EXTRACT_TEXT = 'ai-extract-text',
  AI_GENERATE_WITH_INSTRUCTIONS = 'ai-generate-with-instructions',
  BRANCHING_RULES_TESTER = 'branching-rules-tester',
  P3_HEADER_REDESIGN_FEEDBACK = 'p3-header-redesign-feedback',
  P3_HEADER_EXPAND_TIP = 'p3-header-expand-tip',
  APPLICATION_CHANNEL_AT_MENTIONS = 'application-channel-at-mentions',
  MASS_CHANNEL_CREATE = 'mass-channel-create',
  INBOX_IMPROVEMENTS_LAUNCH_ANNOUNCEMENT = 'inbox-improvements-launch-announcement',
  FRONT_UNWRAPPED_ANNOUNCEMENT = 'front-unwrapped-announcement',
  INBOX_IMPROVEMENT_TOGGLE = 'inbox-improvement-toggle',
  P1_REDESIGN_ADD_BUTTON_ON_EDIT_MODE = 'p1-redesign-add-button-on-edit-mode',
  APP_REQUEST_NODE_IN_MACRO = 'app-request-node-in-macro',
  SLACK_CHANNEL_FLOW_IMPROVEMENTS = 'slack-channel-flow-improvements',
  PLAYBOOKS_ALPHA = 'playbooks-alpha',
}

export const isFeatureFlagsEnum = makeEnumTypeGuard(FeatureFlagsEnum);

// Feature flags targeting 15k+ segments are incorrectly provided by the backend, so we'll wait for the
// client SDK to fetch them instead.
export const clientOnlyFeatureFlags = [FeatureFlagsEnum.ANALYTICS_WORKLOAD_TOUR];
